export default __webpack_public_path__ + "static/media/perodic-open.e32ac80b.svg";